if (Shopify.designMode) {
  // Improve the theme editing experience by making sure certain elements are visible and easiy to edit

  document.documentElement.classList.add('shopify-design-mode');

  let slideshowSelection = null;
  const slideshowOwners = new WeakMap();
  function cancelSlideshowSelection() {
    if (!slideshowSelection) return;
    clearTimeout(slideshowSelection.timer);
    slideshowSelection = null;
  }
  document.addEventListener('shopify:section:unload', function(event) {
    if (slideshowSelection && slideshowSelection.sectionId === event.detail.sectionId) cancelSlideshowSelection();
    const section = event.target;
    disposeProductLightboxes(section);
    if (section instanceof HTMLElement && section.matches('.section--site-header, .section--site-footer')) {
      watchForResize(section);
      setCssVariables(section);
    }
    if (section instanceof HTMLElement && section.matches('.section--menu-drawer, .section--cart-drawer')) {
      section.querySelectorAll('[data-drawer-dialog].open-in-editor').forEach(drawer => drawer.classList.remove('open-in-editor'));
      syncDrawerOverlayState();
    }
  });

  document.addEventListener("shopify:section:load", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (!eventSection) return;
    initializeDetails(eventSection);
    const maps = eventSection.querySelectorAll('google-map');
    const animationContainers = eventSection.querySelectorAll('.animate');
    const swiperContainers = eventSection.querySelectorAll('swiper-container');
    const productMediaGalleries = eventSection.querySelectorAll('.js-product-media-gallery');

    if (eventSection.matches('.section--site-header, .section--site-footer')) {
      setCssVariables();
      watchForResize();
    }

    animationContainers.forEach(container => container.classList.add('animate--loaded'));

    if (maps.length > 0) {
      maps.forEach(map => {
        map.mapAddress();
      });
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      document.documentElement.classList.add('promo-popup-open', 'promo-popup-open-in-editor');
    }

    if (swiperContainers.length > 0) {
      initSwipers(eventSection);
    }

    if (productMediaGalleries.length > 0) {
      initMediaGallery(eventSection);
    }
    initProductLightboxes(eventSection);
  });

  document.addEventListener("shopify:section:select", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (!eventSection) return;

    if (eventSection.matches('.section--menu-drawer, .section--cart-drawer')) {
      const drawer = event.target === eventSection ? eventSection.querySelector('[data-drawer-dialog]') : null;
      if (drawer) drawer.classList.add('open-in-editor');
      syncDrawerOverlayState();
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      if (document.getElementById('promo-popup')) {
        document.getElementById('promo-popup').classList.add('open-in-editor');
        document.documentElement.classList.add('promo-popup-open', 'promo-popup-open-in-editor');
      } else {
        document.documentElement.classList.remove('promo-popup-open', 'promo-popup-open-in-editor');
      }
    }

    if (eventSection.classList.contains('section--age-verifier')) {
      if (document.getElementById('age-verifier')) {
        document.getElementById('age-verifier').classList.add('open-in-editor');
        document.documentElement.classList.add('age-verifier-open');
      } else {
        document.documentElement.classList.remove('age-verifier-open');
      }
    }

  });

  document.addEventListener("shopify:section:deselect", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (!eventSection) return;

    if (eventSection.matches('.section--menu-drawer, .section--cart-drawer')) {
      const drawer = event.target === eventSection ? eventSection.querySelector('[data-drawer-dialog]') : null;
      if (drawer) drawer.classList.remove('open-in-editor');
      syncDrawerOverlayState();
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      if (!document.getElementById('promo-popup')) return;
      document.getElementById('promo-popup').classList.remove('open-in-editor');
      document.documentElement.classList.remove('promo-popup-open', 'promo-popup-open-in-editor');
    }

    if (eventSection.classList.contains('section--age-verifier')) {
      if (!document.getElementById('age-verifier')) return;
      document.getElementById('age-verifier').classList.remove('open-in-editor');
      document.documentElement.classList.remove('age-verifier-open');
    }

  });

  document.addEventListener('shopify:block:select', function(event) {
    cancelSlideshowSelection();
    const eventBlock = event.target;
    const siteHeader = document.getElementById('site-header');

    if (eventBlock.classList.contains('block--accordion')) {
      eventBlock.open();
    }

    if (eventBlock.parentElement.classList.contains('animated-accordion__content')) {
      eventBlock.parentElement.parentElement.open();
    }

    if (eventBlock.classList.contains('block--mega-menu')) {
      eventBlock.parentElement.classList.add('is-open');
      siteHeader.classList.add('mega-menu-open-in-editor');
    }

    if (eventBlock.classList.contains('block--slideshow-slide')) {
      const swiperContainer = eventBlock.parentElement;
      const selectedSlide = eventBlock.dataset.swiperSlideIndex;

      const selection = { block: eventBlock, container: swiperContainer, swiper: swiperContainer.swiper, sectionId: event.detail.sectionId, timer: null };
      slideshowSelection = selection;
      slideshowOwners.set(eventBlock, selection);
      selection.timer = setTimeout(() => {
        if (slideshowSelection !== selection) return;
        selection.timer = null;
        const swiper = swiperContainer.swiper;
        if (!eventBlock.isConnected || eventBlock.parentElement !== swiperContainer || swiper?.destroyed || (selection.swiper && selection.swiper !== swiper)) {
          slideshowSelection = null;
          return;
        }
        selection.swiper = swiper;
        try {
          swiper.autoplay.pause();
          if (slideshowSelection !== selection) return;
          swiper.slideToLoop(selectedSlide, 0, true);
        } catch (error) {
          if (slideshowSelection === selection) slideshowSelection = null;
          throw error;
        }
      }, 10);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const eventBlock = event.target;
    const selection = slideshowOwners.get(eventBlock);
    slideshowOwners.delete(eventBlock);
    if (slideshowSelection && slideshowSelection.block === eventBlock) cancelSlideshowSelection();
    if (!eventBlock.parentElement) return;
    const siteHeader = document.getElementById('site-header');

    if (eventBlock.classList.contains('block--accordion')) {
      eventBlock.close();
    }

    if (eventBlock.parentElement.classList.contains('animated-accordion__content')) {
      eventBlock.parentElement.parentElement.close();
    }

    if (eventBlock.classList.contains('block--mega-menu')) {
      eventBlock.parentElement.classList.remove('is-open');
      siteHeader.classList.remove('mega-menu-open-in-editor');
    }

    if (eventBlock.classList.contains('block--slideshow-slide')) {
      if (!selection) return;
      const swiperContainer = eventBlock.parentElement;
      if (slideshowSelection && slideshowSelection.container === swiperContainer) return;
      if (selection && (selection.container !== swiperContainer || selection.swiper !== swiperContainer.swiper)) return;
      if (!swiperContainer.isConnected || swiperContainer.swiper?.destroyed) return;
      swiperContainer.swiper.autoplay.resume();
    }
  });

}
